import React from "react";
import { observer } from "mobx-react";

import Input from '../../components/Input'

const RawVideoLabels = observer(({ video, timelineState, layoutState, videoMedia }) => {
   if (!video || video.length === 0) return null;

   // Group consecutive keyframes by shared label (same logic as in raw-video-keyframe-timelines)
   const groups = [];
   let currentGroup = null;

   for (const kf of video) {
      if (!currentGroup || currentGroup.label !== kf.label) {
         const groupSrc = videoMedia.find(v => v.src === kf.src);
         const groupStart = groupSrc.userData.find(x => x.label === kf.label).start
         currentGroup = { label: kf.label, value: groupStart, keyframes: [] };
         groups.push(currentGroup);
      }
      currentGroup.keyframes.push(kf);
   }

   const labels = groups.map((group, index) => (
      <RawVideoLabel
         key={`${group.label}-${index}`}
         group={group}
         timelineState={timelineState}
         layoutState={layoutState}
      />
   ));

   return <div className="audio-labels inset">{labels}</div>;
});

const RawVideoLabel = observer(
   class RawVideoLabel extends React.Component {
      select = (e) => {
         e.stopPropagation();
         const { group, timelineState, layoutState } = this.props;
         const { selections } = layoutState;
         const { keyframes } = group;

         const isLocked = timelineState.videoLocked;
         if (isLocked) return;

         // Check if any keyframe in group is already selected
         const anySelected = keyframes.some((kf) =>
            selections.keyframes.includes(kf),
         );

         if (!anySelected && !e.shiftKey) {
            selections.clearAllSelections();
         }

         // Select all keyframes in the group
         keyframes.forEach((kf, index) => {
            // Use shift=true for all but the first to add to selection
            selections.setKeyframeSelection(kf, index > 0 || e.shiftKey);
         });
      };

      render() {
         const { group, timelineState, layoutState } = this.props;
         const { keyframes } = group;
         const { keyframes: selections } = layoutState.selections;

         const name = group.label || "Unlabeled Group";
         const isSelected = keyframes.some((kf) => selections.includes(kf));
         const isLocked = timelineState.videoLocked;
         const property = group.label
        const action = () => {}
        const value = group.value;

         return (
            <div className={`audio-label ${isSelected ? "selected" : ""}`}>
               <button className="indicator" disabled={true}>
                  <i className="sprite timeline caret" />
               </button>
               <div className="asset-name" onMouseUp={this.select}>
                  <span className="truncate">{name}</span>
               </div>
               <div className="asset-properties">
                  <div
                    className={`asset-property ${property} ${isLocked ? 'locked' : ''} ${
                      isSelected ? 'selected' : ''
                    }`}>
                      <div className="inputs">
                        <Input
                          type="text"
                          value={`${value}`}
                          onSave={action}
                          disabled={true}
                          disableOnBlur={false}
                        />
                      </div>
                  </div>
               </div>
            </div>
         );
      }
   },
);

export default RawVideoLabels;
